<!-- 账户设置 -->
<template>
    <div>
        <admin-main-header>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ name: 'Forward', params: {target: 'Index'} }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>个人设置</el-breadcrumb-item>
            </el-breadcrumb>
        </admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 个人设置</span>
                </div>
                <div class="admin-content-main">
                    <el-tabs class="admin-usersettings-tabs" v-model="userActiveTabName" tab-position="left" :style="{height: userTabHeight}" @tab-click="onUserTabClick">
                        <el-tab-pane ref="basicSettings" label="基本设置" name="basicSettings">
                            <div class="admin-usersettings">
                                <h3 class="admin-usersettings-header">基本设置</h3>
                                <div class="admin-usersettings-body">
                                    <el-form ref="userBasicInfoEditForm" label-position="top" label-width="120px" v-custom-validator-apply="userBasicInfoEditRules" :model="userBasicInfoEditForm" :rules="userBasicInfoEditRules">
                                        <el-form-item label="上传头像" prop="userIcon">
                                            <el-upload class="el-upload-plus-uploader user-avatar-uploader" :headers="uploadHeaders" :action="userIconUploadUrl" :data="userIconUploadParam" :show-file-list="false" :before-upload="beforeUserIconUpload" :on-remove="handleUserIconRemove" :on-success="handleUserIconUploadSuccess" :on-error="handleUploadError">
                                                <img class="user-avatar" v-if="userBasicInfoEditForm.userIcon" :src="userBasicInfoEditForm.userIconUrl" title="点击原图片可以重新上传新图片!">
                                                <i v-else class="el-icon-plus el-upload-plus-trigger"></i>
                                                <div class="el-upload__tip" slot="tip">只能上传jpg|png文件，大小不超过50kb，图片像素限90x90像素附近(长宽误差不超过10个像素)，点击原图片可以重新上传新图片!</div>
                                            </el-upload>
                                        </el-form-item>
                                        <el-form-item label="昵称" prop="nickName">
                                            <el-input v-model="userBasicInfoEditForm.nickName" :maxlength="50"></el-input>
                                        </el-form-item>
                                        <el-form-item label="姓名" prop="realName">
                                            <el-input v-model="userBasicInfoEditForm.realName" :maxlength="32"></el-input>
                                        </el-form-item>
                                        <el-form-item label="手机号码" prop="mobilePhone">
                                            <el-input v-model="userBasicInfoEditForm.mobilePhone" :maxlength="11"></el-input>
                                        </el-form-item>
                                        <el-form-item label="电子邮箱" prop="email">
                                            <el-input v-model="userBasicInfoEditForm.email" :maxlength="100"></el-input>
                                        </el-form-item>
                                        <el-form-item label="邀请码" prop="inviteCode">
                                            <el-input v-model="userBasicInfoEditForm.inviteCode" :maxlength="18"></el-input>
                                        </el-form-item>
                                        <el-form-item label="所属组织机构" prop="orgId">
                                            <el-col :span="24">
                                                <el-select v-model="userBasicInfoEditForm.orgId" filterable :filter-method="filterAllOrgs" @visible-change="resetOrgSelectFilterQuery" class="el-full-width">
                                                    <el-option v-for="item in userEditOrgSelectOptions" :key="item.orgId" :label="item.orgName" :value="item.orgId" class="org-select-option">
                                                        <span class="option-left">{{ item.orgCode }}</span>
                                                        <span class="option-right">{{ item.orgName }}</span>
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="primary" icon="far fa-save" @click="saveUserBasicInfo" :loading="submiting">保 存</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane ref="modifyPassword" label="修改密码" name="modifyPassword">
                            <div class="admin-usersettings">
                                <h3 class="admin-usersettings-header">修改密码</h3>
                                <div class="admin-usersettings-body">
                                    <el-form ref="changePwdForm" label-position="top" label-width="120px" v-custom-validator-apply="changePwdRules" :model="changePwdForm" :rules="changePwdRules">
                                        <el-form-item label="旧密码" prop="oldpassword">
                                            <el-input v-model="changePwdForm.oldpassword" :maxlength="20" type="password" autocomplete="new-password"></el-input>
                                        </el-form-item>
                                        <el-form-item label="新密码" prop="password">
                                            <el-input v-model="changePwdForm.password" :maxlength="20" type="password" autocomplete="new-password"></el-input>
                                        </el-form-item>
                                        <el-form-item label="确认密码" prop="repassword">
                                            <el-input v-model="changePwdForm.repassword" :maxlength="20" type="password" autocomplete="new-password"></el-input>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="primary" icon="far fa-save" @click="changePassword" :loading="submiting">提 交</el-button>
                                        </el-form-item>
                                    </el-form>

                                    <el-alert v-if="changePwdSuccess" type="success" :title="changePwdSuccessMessage" show-icon></el-alert>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane ref="securitySettings" label="安全设置" name="securitySettings">
                            <div class="admin-usersettings">
                                <h3 class="admin-usersettings-header">安全设置</h3>
                                <div class="admin-usersettings-body">
                                    <el-switch v-model='isOrgSelf' @change='changeOrgSelf' :disabled='!isSystemUser'></el-switch>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane ref="personality" label="个性化" name="personality">
                            <div class="admin-usersettings">
                                <h3 class="admin-usersettings-header">个性化</h3>
                                <div class="admin-usersettings-body">
                                    <p>暂无数据</p>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { COMMON_PATTERNS } from '@/utils.js';
import { CustomValidator } from '@/plugins';
import { ADMIN_LOGIN_URL } from '@/constants.js';

const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export default {
    name: 'UpmsUserCenter',
    data() {
        return {
            submiting: false,
            userActiveTabName: 'basicSettings',
            userBasicInfoEditForm: {
                nickName: '',
                realName: '',
                mobilePhone: '',
                email: '',
                inviteCode: '',
                userIcon: '',
                userIconUrl: '',
                orgId: ''
            },
            userBasicInfoEditRules: {
                realName: [
                    {
                        required: true,
                        message: '请输入姓名!'
                    }
                ],
                mobilePhone: [
                    {
                        pattern: COMMON_PATTERNS.MOBILE,
                        message: '手机号码不合法!'
                    }
                ],
                email: [
                    {
                        type: 'email',
                        message: 'EMAIL不合法!'
                    }
                ],
                inviteCode: [
                    {
                        required: true,
                        message: '请输入邀请码!'
                    }
                ],
                orgId: [
                    {
                        type: 'integer',
                        required: true,
                        message: '请选择一个所属组织机构!'
                    }
                ]
            },
            userIconUploadUrl: PLATFORM_API.of('/api/xupload/public/image'),
            userIconUploadParam: {
                formatLimit: 'jpeg,jpg,png',
                pixelLimit: '90x90'
            },
            changePwdForm: {
                oldpassword: '',
                password: '',
                repassword: ''
            },
            changePwdRules: {
                oldpassword: [
                    {
                        required: true,
                        message: '请输入原密码!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,20}$/,
                        message: '账户密码由6~20个字母或数字组成!'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: '请输入新密码!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,20}$/,
                        message: '账户密码由6~20个字母或数字组成!'
                    }
                ],
                repassword: [
                    {
                        required: true,
                        message: '请再次输入新密码!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,20}$/,
                        message: '账户密码由6~20个字母或数字组成!'
                    },
                    {
                        validator: CustomValidator.equalTo,
                        compareTarget: {
                            form: 'changePwdForm',
                            field: 'password'
                        },
                        message: '两次密码输入不一致!'
                    }
                ]
            },
            userTabHeight: 'auto',
            userTabMinHeight: 160,
            changePwdSuccess: false,
            logoutCountDown: 10,
            allOrgList: [],
            orgSelectFilterQuery: '',

            isOrgSelf: false,
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        userEditOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter(org => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                let allOrgs = this.allOrgList.filter(org => true);
                allOrgs.unshift({ orgId: 0, orgName: '全部', orgCode: 'ALL' });
                return allOrgs;
            }
        },
        uploadHeaders() {
            let headers = {
                Accept: 'application/json'
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        },
        changePwdSuccessMessage() {
            return `修改密码成功！${this.logoutCountDown} 秒后即将退出系统重新登录...`;
        },
        isSystemUser() {
            return this.loginUser.userType == 0;
        }
    },
    created() {
        this.initUserBasicInfoForm();
        this.userTabMinHeight = this.adminContentMinHeight - 60 - 20 * 2;
        this.loadAllOrgList();
    },
    mounted() {
        this.setUserTabHeight(this.$refs[this.userActiveTabName]);

        this.isOrgSelf = this.$store.state.isOrgSelf;
    },
    methods: {
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        initUserBasicInfoForm() {
            Object.keys(this.userBasicInfoEditForm).forEach(name => {
                this.userBasicInfoEditForm[name] = this.loginUser[name];
            });
        },
        setUserTabHeight(tab) {
            let minHeight = tab.$el.offsetHeight;
            if (minHeight > this.userTabMinHeight) {
                this.userTabHeight = minHeight + 'px';
            } else {
                this.userTabHeight = this.userTabMinHeight + 'px';
            }
        },
        onUserTabClick(tab) {
            Vue.nextTick(() => {
                this.setUserTabHeight(tab);
            });
        },
        saveUserBasicInfo() {
            let url = PLATFORM_API.of(
                '/api/platform/login/user/settings/basicinfo'
            );
            this.$refs.userBasicInfoEditForm.validate(valid => {
                if (valid && !this.submiting) {
                    this.$confirm('您确定要修改您的基本信息?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .put(url, this.userBasicInfoEditForm)
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.$message.success(result.message);
                                        this.storeLoginUser(result.data);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    });
                } else {
                    return false;
                }
            });
        },
        storeLoginUser(loginUser) {
            let loginUserAllData = this.$store.state.loginUserAllData;
            loginUserAllData.loginUser = loginUser;
            this.$store.dispatch(
                'executeUpdateLoginUserAllData',
                loginUserAllData
            );
        },
        changePassword() {
            let url = PLATFORM_API.of(
                '/api/platform/login/user/settings/changepwd'
            );
            this.$refs.changePwdForm.validate(valid => {
                if (valid && !this.submiting) {
                    this.$confirm('您确定要修改密码吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .put(url, this.changePwdForm)
                                .then(response => {
                                    this.submiting = false;
                                    let result = response.data;
                                    if (result.success) {
                                        this.changePwdSuccess = true;
                                        this.logoutCountDown = 10;
                                        let interval = setInterval(() => {
                                            //倒计时退出
                                            if (this.logoutCountDown > 0) {
                                                this.logoutCountDown =
                                                    this.logoutCountDown - 1;
                                            }
                                            if (this.logoutCountDown == 0) {
                                                clearInterval(interval);
                                                this.resetStore(); //reset vuex store
                                                window.location.href = ADMIN_LOGIN_URL;
                                            }
                                        }, 1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    });
                } else {
                    return false;
                }
            });
        },
        resetStore() {
            this.$store.dispatch('resetStore4Logout');
        },
        beforeUserIconUpload(file) {
            let fileType = file.type;
            if (IMAGE_TYPES.indexOf(fileType) == -1) {
                this.$message.error('上传图片只能是jpg、png格式!');
                return false;
            }
            if (file.size > 0 && file.size / 1024 > 50) {
                this.$message.error('上传图片大小不能超过50KB!');
                return false;
            }
            return true;
        },
        handleUserIconUploadSuccess(response, file, fileList) {
            file.url = response.data.url;
            file.path = response.data.path;
            this.userBasicInfoEditForm.userIcon = response.data.path;
            this.userBasicInfoEditForm.userIconUrl = response.data.url;
        },
        handleUserIconRemove(file, fileList) {
            if (file && file.path) {
                this.$http.get(
                    PLATFORM_API.of(
                        '/api/xupload/public/remove?path=' + file.path
                    )
                );
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        },
        changeOrgSelf(val) {
            let url = PLATFORM_API.of('/api/platform/admin/checkOrgAuth');
            this.$http.post(url).then(response => {
                let result = response.data;
                if (result.success) {
                    this.$message.success(this.isOrgSelf ? '已打开' : '已关闭');
                } else {
                    this.isOrgSelf = !this.isOrgSelf;
                }
            }).catch(err => {
                defaultApiErrorHandler(err);
                this.isOrgSelf = !this.isOrgSelf;
            });
        }
    }
};
</script>

<style lang="scss">
.admin-content-main {
    padding-top: 20px !important;
}
.admin-usersettings {
    display: block;
    position: relative;
    padding: 0 30px;
    margin: 0;

    .admin-usersettings-header {
        display: block;
        margin: 0;
        padding: 0;
        line-height: 40px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
        font-weight: 500;
    }

    .admin-usersettings-body {
        display: block;
        margin: 0;
        padding: 0;
    }
}
.admin-usersettings-tabs {
    .el-tabs__item.is-left {
        min-width: 200px;
        padding: 0 30px;
    }
    .el-tabs__header.is-left {
        margin-right: 0;
    }
    .el-tabs__item.is-left.is-active {
        background-color: $--color-primary-light-9;
    }
}
.user-avatar {
    width: 90px;
    height: 90px;
    display: block;
    margin: 5px;
}
.logout-countdown {
    line-height: 32px;
    font-size: 20px;
    color: $--color-green;
}
</style>